export class RewardConfigurator {
  /**
   * BTEConfigurator
   * Control a BTE Configurator
   * @param {HTMLElement} element Configurator
   */
  constructor(element) {
    // Name
    element.RewardConfigurator = this;

    // Refs
    this._refs = {
      el: element,
      flexpoints: element.querySelector('.configurator__quantity-panel'),
      numberInput: element.querySelector('.number-input'),
    };

    // Properites
    this._props = {
      manager: window.Sys.WebForms.PageRequestManager.getInstance(),
    };

    // this._onLoad();

    // // Updatepanel - callback event attachments
    if (typeof this._props.manager !== 'undefined' && this._props.manager !== null) {
      if (this._refs.numberInput != null) {
        this._refs.numberInput.addEventListener(
          'numberinput.updated',
          this._onNumberInputUpdate.bind(this),
        );
      }
    }
  }

  _onNumberInputUpdate({ detail }) {
    if (this._refs.flexpoints === null) return;

    // Flexpoint calculation
    const oItemUnitValue = parseInt(this._refs.flexpoints.dataset.value);

    if (oItemUnitValue === null) return;

    this._refs.flexpoints.innerHTML = (oItemUnitValue * detail.value).toLocaleString('en-US', {
      maximumFractionDigits: 2,
    });
  }

  /**
   * Handler for binding events eg. when page is loading
   */
  _onLoad() {}

  /**
   * Handler for rebinding event eg. after an update has occoured
   */
  _onCallback() {
    /* eslint-disable-next-line */
    this._props.manager.add_endRequest((sender, e) => {});
  }
}
